export const mockListings = [
    {
        id: 1,
        name: "George Tan",
        price: "21.85",
        area: "Bandar Sunway/Subang Jaya",
        date: "2022-09-10",
    },
    {
        id: 2,
        name: "Nitin Mathew",
        price: "33.42",
        area: "Skudai/Johor Bahru",
        date: "2022-09-26",
    },
    {
        id: 3,
        name: "Samuel Tai",
        price: "52.65",
        area: "Skudai/Johor Bahru",
        date: "2022-10-11",
    },
    {
        id: 4,
        name: "Naavin Ravinthran",
        price: "29.78",
        area: "Petra Jaya/Kuching",
        date: "2022-11-12",
    },
    {
        id: 5,
        name: "Tee Shun Yao",
        price: "15.69",
        area: "Bandar Sunway/Subang Jaya",
        date: "2022-12-31",
    },
];

export const mockLeaderboardData = [
    {
        id: 1,
        name: "George Tan",
        electricityDonated: "920",
        recentActivity: "8 minutes ago",
    },
    {
        id: 2,
        name: "Nitin Mathew",
        electricityDonated: "895",
        recentActivity: "55 minutes ago",
    },
    {
        id: 3,
        name: "Samuel Tai",
        electricityDonated: "420",
        recentActivity: "1 day ago",
    },
    {
        id: 4,
        name: "Naavin Ravinthran",
        electricityDonated: "400",
        recentActivity: "2 weeks ago",
    },
    {
        id: 6,
        name: "Tee Shun Yao",
        electricityDonated: "360",
        recentActivity: "7 weeks ago",
    },
];

export default mockListings;
